import {extractShippingMethod} from '@ppcp/utils';
import Actions from '@ppcp/actions';

const actions = new Actions();

let isMondialSelected = false;

actions.addAction('checkout_on_shipping_change', (data) => {
    isMondialSelected = false;
    if (data.shipping_method) {
        const shippingMethod = extractShippingMethod(data.shipping_method);
        // check if Mondial shipping method
        for (let index of Object.keys(shippingMethod)) {
            const method = shippingMethod[index];
            if (method.includes("mondialrelay_official_shipping")) {
                isMondialSelected = true;
            }
        }
    }
})

actions.addFilter('checkout_submit_form', (bool) => {
    if (bool && isMondialSelected) {
        bool = false;
    }
    return bool;
});